import { useState } from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n";
import { Reveal, SectionHead } from "./Reveal";

export const Sectors = () => {
  const { t } = useI18n();
  const [active, setActive] = useState(0);
  const items = t.sectors.items;
  return (
    <section id="sectors" data-testid="sectors-section" className="border-t border-white/10 py-24 lg:py-40">
      <div className="wrap">
        <SectionHead label={t.sectors.label} title={t.sectors.title} />
        <div className="mt-16 grid gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="hidden lg:col-span-5 lg:block">
            <div className="notch sticky top-28 aspect-[4/5] overflow-hidden bg-ink-2">
              {items.map((s, i) => (
                <motion.img key={s.title} src={s.img} alt={active === i ? s.alt : ""} aria-hidden={active !== i} className="absolute inset-0 h-full w-full object-cover"
                  initial={false} animate={{ opacity: active === i ? 1 : 0, scale: active === i ? 1 : 1.08 }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }} />
              ))}
              <div aria-hidden className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
              <span className="absolute bottom-6 left-6 font-mono text-xs uppercase tracking-[0.2em] text-bone">0{active + 1} / 0{items.length}</span>
            </div>
          </div>
          <ul className="border-t border-white/10 lg:col-span-7">
            {items.map((s, i) => (
              <Reveal as="li" key={s.title} delay={i * 0.05} onMouseEnter={() => setActive(i)} data-testid={`sector-row-${i + 1}`} className="border-b border-white/10 py-8 lg:py-10">
                <div className="flex items-baseline gap-5 sm:gap-8">
                  <span className="font-mono text-xs text-zinc-400">0{i + 1}</span>
                  <div className="min-w-0 flex-1">
                    <h3 className={`font-display text-3xl font-semibold tracking-tight transition-[color,transform] duration-500 sm:text-4xl lg:text-5xl ${active === i ? "lg:translate-x-3 lg:text-signal" : ""}`}>{s.title}</h3>
                    <p className="mt-3 max-w-lg text-zinc-400">{s.desc}</p>
                    <img src={s.img} alt={s.alt} loading="lazy" className="mt-6 aspect-[16/9] w-full object-cover lg:hidden" />
                  </div>
                </div>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
